import axios from 'axios';
import { getAPIHost } from './apihost';

export function getUserRoles() {
    return axios.get(getAPIHost() + '/user_roles');
}